import {
  tableState,
  tableMutations,
  tableActions,
  tableGetters
} from "@tt/vue-components";
import AttributeService from "@/services/AttributeService";
import searchHelper from "@/helpers/searchHelper";

const inputValueIgnoredOverview = {
  namespaced: true,
  state: {
    ...tableState,
    ignoredStatus: true,
    value: null,
    valueSearch: "",
    search: [
      {
        column: "type",
        value: "input"
      }
    ],
    sortByField: ["content"],
    sortDesc: false
  },
  mutations: {
    ...tableMutations,
    SET_IGNOREDSTATUS(state, value) {
      state.ignoredStatus = value;
    },
    SET_VALUESEARCH(state, value) {
      state.valueSearch = value;
    },
    SET_VALUE(state, value) {
      state.value = value;
    }
  },
  actions: {
    ...tableActions,
    fetchItems(context, refresh = false) {
      if (refresh || context.state.items.length === 0) {
        context.commit("SET_ERROR", false);
        context.commit("SET_LOADING", true);
        AttributeService.fetchValues(
          context.state.itemsPage,
          context.state.itemsPerPage,
          context.state.sortByField,
          context.state.sortDesc,
          context.state.search
        )
          .then(json => {
            context.commit("SET_ITEMS", json);
            context.commit("SET_LOADING", false);
          })
          .catch(err => {
            context.commit("SET_ERROR", true);
            context.commit("SET_LOADING", false);
            console.log(err);
            console.log(context.state.search);
          });
      }
    },
    setValueSearch(context, value) {
      context.commit("SET_VALUESEARCH", value);
    },
    setValue(context, value) {
      context.commit("SET_VALUE", value);
    },
    searchItems(context) {
      var data = [...context.state.search];

      data = searchHelper.handleSearchParam(
        data,
        "attribute",
        context.rootState.attributeOverview.attribute.id
      );

      data = searchHelper.handleSearchParam(
        data,
        "content",
        context.state.valueSearch
      );

      data = searchHelper.handleSearchParam(
        data,
        "ignored",
        context.state.ignoredStatus
      );

      data = searchHelper.handleSearchParam(data, "type", "input");

      // fill the search again
      context.commit("EMPTY_SEARCH");
      if (Array.isArray(data) && data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          context.commit("ADD_SEARCH", {
            column: data[i].column,
            value: data[i].value
          });
        }
      }

      context.dispatch("fetchItems", true);
    },
    editValue(context, value) {
      return new Promise((resolve, reject) => {
        AttributeService.editValue(value, value["id"])
          .then(() => {
            context.dispatch("fetchItems", true);
            context.dispatch(
              "attributeOverview/inputValueOverview/fetchItems",
              true,
              { root: true }
            );
            context.dispatch("attributeOverview/attributeOv/fetchItems", true, {
              root: true
            });
            resolve();
          })
          .catch(err => {
            reject(err["hydra:description"]);
          });
      });
    }
  },
  getters: {
    ...tableGetters
  }
};

export default inputValueIgnoredOverview;
